import React from 'react'
import DefaultForm from '../../../../../ui/forms/default-form'
import CancelCertificateForm from '../../../../accs/form/cancel-certificate'
import { hasAvailableAction } from '../../../../../ui/gov-actions'

const formValue = 'cancel_certificate'

const available = (record) => hasAvailableAction(record, 'cancel_certificate')

const calculateSubmitValues = (values) => {
  const submitValues = { ...values }
  return submitValues
}

const defaultValues = (certificateID) => {
  return {
    certificate_id: certificateID,
    is_declaration_given: null,
    cancelation_reason: ''
  }
}

const actionForm = ({ child, regHolderId, record }) => ({ handleSuccess }) => {
  const certificateID = record.gov_record.certificateID

  return (
    <DefaultForm
      url={
        process.env.REACT_APP_API_HOST +
        `/api/services/${regHolderId}/accs/certificate/${certificateID}/cancel`
      }
      name={formValue}
      label='Stop Certificate'
      calculateSubmitValues={calculateSubmitValues}
      handleSuccess={() =>
        handleSuccess(
          { [formValue]: 'ACCS Certificate has been cancelled.' },
          formValue
        )
      }
      formOptions={{ defaultValues: defaultValues(certificateID) }}
      formComponent={(props) => (
        <CancelCertificateForm {...props} required={false} child={child} />
      )}
    />
  )
}

export const cancelCertificate = ({
  regHolderId,
  child,
  record,
  refresh_accs_gov_enrolments
}) => {
  return available(record)
    ? {
        label: 'Cancel Certificate',
        value: 'cancel_certificate',
        actionForm: actionForm({ record, regHolderId, child }),
        onCompletePreserveAction: true,
        onComplete: refresh_accs_gov_enrolments
      }
    : null
}



// WEBPACK FOOTER //
// ./src/care-enrolments/details/accs-gov-enrolments/actions/cancel-certificate/index.js